import React from 'react';

import { SVGComponentProps } from './svg.types';

const EditHideSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M19 20.498L16.614 18.027C15.1661 18.6862 13.5908 19.0184 12 19C10.3599 19.0204 8.73671 18.6664 7.254 17.965C6.10468 17.4042 5.07264 16.6298 4.213 15.683C3.30049 14.7049 2.5833 13.5613 2.1 12.314L2 12L2.105 11.684C2.82781 9.84029 4.04426 8.23116 5.621 7.033L3.7065 5.1185C3.31635 4.72835 3.31646 4.09576 3.70675 3.70575C4.09684 3.31593 4.72905 3.31605 5.119 3.706L20.6759 19.2629C21.066 19.653 21.0665 20.2854 20.6769 20.6761L20.6467 20.7064C20.2692 21.0849 19.6607 21.0996 19.2654 20.7397L19 20.498ZM7.036 8.449C5.75792 9.34491 4.74865 10.5727 4.117 12C5.47142 15.1249 8.59587 17.1067 12 17C13.0498 17.0086 14.0936 16.8396 15.087 16.5L13.287 14.7C12.8863 14.8964 12.4462 14.999 12 15C10.3475 14.9896 9.01037 13.6525 9 12C9.00048 11.5528 9.10309 11.1116 9.3 10.71L7.036 8.449ZM20.5 15C20.139 15.3399 19.5732 15.3314 19.2225 14.9809L19.1256 14.8841C18.7516 14.5104 18.7387 13.9134 19.0436 13.4815C19.3713 13.0173 19.6526 12.5211 19.883 12C18.5304 8.87358 15.4047 6.89108 12 7C11.753 7 11.505 7.009 11.265 7.026L10.7987 6.55916C10.2387 5.99853 10.5285 5.05949 11.3197 5.01686C11.5462 5.00466 11.773 4.99903 12 5C13.6401 4.97965 15.2633 5.33362 16.746 6.035C17.8953 6.59573 18.9274 7.37019 19.787 8.317C20.6991 9.29396 21.4163 10.4361 21.9 11.682L22 12L21.895 12.316C21.4268 13.5341 21.3812 14.0375 20.5 15Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default EditHideSVG;
